/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for SchoolSubscriptionLevelCtl controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_VERSUSCLIENT, CLIENT_CONTEXT_TOKEN_VERSUSCLIENT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { SchoolSubsClassDto, RequestOptions, SchoolClass, SchoolLevelDto } from "../models";

@Injectable({ providedIn: "root" })
export class SchoolSubscriptionLevelCtlService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_VERSUSCLIENT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_VERSUSCLIENT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'VersusClient');
    }

    addSubscriptionByLevel(schoolSubsClassDto: SchoolSubsClassDto, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    addSubscriptionByLevel(schoolSubsClassDto: SchoolSubsClassDto, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    addSubscriptionByLevel(schoolSubsClassDto: SchoolSubsClassDto, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    addSubscriptionByLevel(schoolSubsClassDto: SchoolSubsClassDto, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/schools/subscriptions/levels`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: schoolSubsClassDto,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    updateSubscriptionByLevel(schoolSubsClassDto: SchoolSubsClassDto, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    updateSubscriptionByLevel(schoolSubsClassDto: SchoolSubsClassDto, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    updateSubscriptionByLevel(schoolSubsClassDto: SchoolSubsClassDto, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    updateSubscriptionByLevel(schoolSubsClassDto: SchoolSubsClassDto, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/schools/subscriptions/levels`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('put', url, {
            body: schoolSubsClassDto,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    deleteSubscriptionByLevel(idLevel: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    deleteSubscriptionByLevel(idLevel: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    deleteSubscriptionByLevel(idLevel: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    deleteSubscriptionByLevel(idLevel: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/schools/subscriptions/levels`;

        let params = new HttpParams();
        if (idLevel != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idLevel, 'idLevel');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('delete', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getClassByLevel(level: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<SchoolClass>>;
    getClassByLevel(level: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<SchoolClass>>>;
    getClassByLevel(level: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<SchoolClass>>>;
    getClassByLevel(level: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/schools/subscriptions/levels/classes`;

        let params = new HttpParams();
        if (level != null) {
            params = HttpParamsBuilder.addToHttpParams(params, level, 'level');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getSubscriptionLevelByPartner(idSchool: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<SchoolSubsClassDto>>;
    getSubscriptionLevelByPartner(idSchool: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<SchoolSubsClassDto>>>;
    getSubscriptionLevelByPartner(idSchool: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<SchoolSubsClassDto>>>;
    getSubscriptionLevelByPartner(idSchool: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/schools/subscriptions/levels/by-partner`;

        let params = new HttpParams();
        if (idSchool != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idSchool, 'idSchool');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getAllSchoolLevel(observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<SchoolLevelDto>>;
    getAllSchoolLevel(observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<SchoolLevelDto>>>;
    getAllSchoolLevel(observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<SchoolLevelDto>>>;
    getAllSchoolLevel(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/schools/subscriptions/levels/all`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
